export default __webpack_public_path__ + "static/media/home.432c072a.svg";